import * as yup from 'yup';

const YupFirestoreTimestamp = yup.mixed().test(
  'is-firestore-timestamp',
  'Invalid Firestore timestamp',
  // Firestore Timestamp objects (from both firebase and firebase-admin)
  // expose a .toDate() method, so we check for that instead of using instanceof.
  // instanceof fails if different Firebase SDK instances or packages are used.
  (value) => {
    // If optional/nullable, let those pass here; `.required()` will enforce presence when used.
    if (value === null || value === undefined) return true;
    return typeof value?.toDate === 'function';
  },
);

export default YupFirestoreTimestamp;
